import { Box, Typography } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const searchNoMatchesMessage = defineMessage({
  id: 'fragments.transcription.v2.searchNoMatches',
  defaultMessage: 'Sin coincidencias',
});

/**
 * Empty state when the transcript search has no matching blocks (replaces the block list area).
 */
export function TranscriptionSearchNoMatches() {
  const { formatMessage } = useIntl();

  return (
    <Box
      sx={{
        maxHeight: 500,
        minHeight: (theme) => theme.spacing(15),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 3,
      }}
    >
      <Typography variant="body2" color="text.secondary" textAlign="center">
        {formatMessage(searchNoMatchesMessage)}
      </Typography>
    </Box>
  );
}
